import React, { useState } from 'react'
import baseUrl from '../../components/baseUrl'
import visibility_on from './assets/visibility_on.svg'
import visibility_off from './assets/visibility_off.svg'
import successIcon from '../../components/assets/success.svg'
import VerifyOTP from '../../components/VerifyOTP/VerifyOTP'
import axios from 'axios'
import errorIcon from '../../components/assets/error.svg'
import codeSentIcon from '../../components/assets/codeSent.svg'
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const ForgotPassword = ({ forgotPasswordSteps, setForgotPasswordSteps, scrollToTop, correctOtp, setCorrectOtp, setEnterOTP, progressBar, setProgressBar }) => {

  const [codes, setCodes] = useState(['', '', '', '', '', '']);

  const [alertMessage, setAlertMessage] = useState("")


  const [errorMessage, setErrorMessage] = useState("")
  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [strength, setStrength] = useState(0);
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false); // Track loading state


  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const tester = (value) => {
    let criteriaMet = 0;

    if (value.length >= 8) criteriaMet++;
    if (/[A-Z]/.test(value)) criteriaMet++;
    if (/[a-z]/.test(value)) criteriaMet++;
    if (/\d/.test(value)) criteriaMet++;
    if (/[!@#$%^&*]/.test(value)) criteriaMet++;

    return criteriaMet
  }

  const passwordOnChange = (value) => {
    setPassword(value)
    setStrength(tester(value));
  }

  const handlePasswordChange = (newPassword) => {
    // checkPasswordStrength(newPassword);
    // console.log(getPasswordStrengthIndicator())
    // Regular expressions to check for lowercase, uppercase, and special characters
    const lowercaseRegex = /[a-z]/;
    const uppercaseRegex = /[A-Z]/;
    const numeric = /[0-9]/;
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;

    // Check if the password meets the criteria
    const containsLowercase = lowercaseRegex.test(newPassword);
    const containsUppercase = uppercaseRegex.test(newPassword);
    const containsNumeric = numeric.test(newPassword)
    const containsSpecialChar = specialCharRegex.test(newPassword);

    if (!containsLowercase) {
      return "Password Must Contain atleast 1  lowercase"
    }
    else if (!containsUppercase) {
      return "Password Must Contain atleast 1 uppercase"
    }
    else if (!containsNumeric) {
      return "Password Must Contain atleast 1 numeric"
    }
    else if (!containsSpecialChar) {
      return "Password Must Contains atleast 1 special character"
    }
    else {
      return ""
    }
  };

  const switchToCodeInput = (value) => {
    setForgotPasswordSteps(value)
    setProgressBar(value)
    scrollToTop()
  }
  const switchToPasswordReset = (value) => {
    setForgotPasswordSteps(value)
    setProgressBar(value)
    scrollToTop()
  }

  const handleNewPassword = async (e) => {
    e.preventDefault();

    // Check if passwords match
    if (password !== confirmPassword) {
        setErrorMessage("Passwords do not match");
        return; // Stop further execution
    }

    const data = JSON.stringify({
        email: email,
        otp: correctOtp,
        isHeroku: false,
        newPassword: password
    });

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${baseUrl}/auth/set-new-password`,
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    await axios.request(config)
        .then((response) => {
            setErrorMessage('');
            switchToPasswordReset(3);
        })
        .catch((error) => {
            const errorMsg = error?.response?.data?.msg;
            setErrorMessage(errorMsg);
        });
};



const requestPasswordReset = async (e) => {
  e.preventDefault();
  if (!email) {
    setErrorMessage("Please enter your email");
    return;
  }

  setLoading(true); // Show loading state when request starts

  try {
    const { data } = await axios.post(`${baseUrl}/auth/request-password-reset`, { email });

    setErrorMessage('');
    setAlertMessage(data?.msg);

    setTimeout(() => {
      switchToCodeInput(1);
    }, 2000);
  } catch (error) {
    setErrorMessage(error?.response?.data?.msg || "An error occurred. Please try again.");
  } finally {
    setLoading(false); // Ensure loading is set to false after request completion
  }
};



  return (
    <div className='w-full flex flex-col h-full justify-between gap-2 md:gap-[60px] lg:gap-[60px] lg:gap-[100px] lg:justify-between xl:justify-between pb-[56px] lg:pb-0 '>
      {forgotPasswordSteps === 0 ?
        <div className='  flex flex-col justify-center items-center text-center '>
          <h1 className=' mt-[20px] lg:mt-0 font-black text-sm text-ravblue '>Forgot Password?</h1>
          <p className=' mt-[9px] lg:mt-[12px] font-medium text-base text-ravinput '>No worries, we will send you reset instructions.</p>
          <p className='  font-medium text-base text-ravinput'>Enter your email to receive the instructions</p>

         

          <form onSubmit={requestPasswordReset} className='mt-[31px] lg:mt-[36px] w-full flex flex-col gap-[13px] lg:gap-[15px] items-center'>
            {/**Message div */}
            <div className={` ${errorMessage?.length == 0 && alertMessage?.length == 0 ? "hidden" : "flex"} w-full flex-col `}>
              {errorMessage?.length > 0 ? <h1 className={`bg-[#FFDFE4]  text-[#EB0728]  h-[30px] flex justify-center items-center text-center rounded-[30px]  w-full text-[10px] leading-[12.13px]`}>
                <img src={errorIcon} alt="" className='size-[14px] mr-1' />
                {errorMessage}
              </h1> : null}


              {alertMessage?.length > 0 ? <h1 className={`bg-[#D6FBC9]  text-[#4FBF26] h-[30px] flex justify-center items-center text-center rounded-[30px]  w-full text-[10px] leading-[12.13px]`}>
                <img src={codeSentIcon} alt="" className='size-[14px] mr-1' />
                {alertMessage}
              </h1> : null}
            </div>
            <input required value={email} onChange={(e) => setEmail(e.target.value)} type="email" name="email" id="email" placeholder='Email' className=' w-full  h-[45px] lg:h-[50px] rounded-[80px] bg-[#E5E5E580] bg-opacity-50 flex items-center text-[15px] text-black leading-[20.25px] px-[20px] md:px-[23px]  lg:px-[29px] placeholder:text-ravinput focus:outline-[#0079FF]' />
            <button type="submit" disabled={loading} className=' w-full  h-[45px] lg:h-[50px] rounded-[80px] bg-ravblue flex items-center justify-center text-center font-bold text-sm text-white  hover:opacity-70 transform transition-all ease-in-out duration-300'> {/* Spinner overlay */}
              {loading ? (
                <AiOutlineLoading3Quarters className="absolute animate-spin" />)

                : (<span>
                  Reset Password
                </span>
                )}
            </button>
          </form>


          <button onClick={() => { setForgotPasswordSteps(-1); scrollToTop() }} type="button" className=' mt-[18px] lg:mt-[30px] font-bold text-xs lg:text-base text-ravinput hover:text-opacity-70 transform transition-all ease-in-out duration-300'>BACK TO LOGIN</button>
        </div>
        : null}

      {forgotPasswordSteps === 1 ?
        <VerifyOTP verifyType="passwordReset" setCorrectOtp={setCorrectOtp} setEnterOTP={setEnterOTP} setForgotPasswordSteps={setForgotPasswordSteps} email={email} setProgressBar={setProgressBar} />
        : null}

      {forgotPasswordSteps === 2 ?
        <div className='  flex flex-col justify-center items-center text-center '>
          <h1 className=' mt-[17px] sm:mt-0 font-black text-ml lg:text-[24px] leading-[32.4px] mg:text-xxl text-ravdeepblue'>Change password</h1>
          <p className=' mt-[8px] sm:mt-[3px] font-medium text-base text-ravash '>Password should be longer than 8 characters</p>
          <form onSubmit={handleNewPassword} className=' mt-[29px] w-full flex flex-col gap-[10px] lg:gap-[15px]'>

          {handlePasswordChange(password) === "Password Must Contain atleast 1 numeric" || errorMessage === "Password is Required" || errorMessage === "Password is too short" || errorMessage === "Passwords do not match"
                  || handlePasswordChange(password) === "Password Must Contain atleast 1  lowercase" ||
                  handlePasswordChange(password) === "Password Must Contain atleast 1 uppercase" ||
                  handlePasswordChange(password) === "Password Must Contains atleast 1 special character" ? <h1 className=' pl-5 w-full  text-[#EB0728] text-[12px] text-left'>{password.length > 0 && handlePasswordChange(password) !== "" ? handlePasswordChange(password) :
                    (password.length < 4 && errorMessage === "Password is Required") ||
                      (password.length < 4 && errorMessage === "Password is too short") ||
                      errorMessage === "Passwords do not match" ? errorMessage : ""}</h1> : null}
            {/** Password */}
            <div className='box-border m-0 flex-grow-0 max-w-full'>
              <div className=' box-border flex flex-wrap w-full'>

                <div className='relative w-full flex items-start '>
                  <input value={password} onChange={(e) => passwordOnChange(e.target.value)} required type={showPassword ? "text" : "password"} name="password" id="password" data-cy="password" placeholder="New Password" className={`
                      ${(password.length > 0 && handlePasswordChange(password) !== "") ||
                      (password.length < 4 && errorMessage === "Password is Required") ||
                      (password.length < 4 && errorMessage === "Password is too short") ||
                      errorMessage === "Passwords do not match"
                      ? " border-[1px] border-[#EB0728]" : ""} 
                        m-0 placeholder:text-ravinput textravdeepblue text-base lg:text-[15px] w-full font-medium bg-ravbg h-[45px] lg:h-[50px] rounded-[30px]  pl-[20px] md:pl-[23px]  lg:pl-[29px] `} />
                  <div className=' flex gap-[5px] absolute inset-y-0 right-[60px] items-center'>
                    <div className={` ${password.length < 1 ? "bg-[#D9D9D9]" : password.length < 6 ? "bg-[#EB0728]" : strength <= 2 ? "bg-[#EB0728]" : strength === 3 ? " bg-yellow-300" : strength >= 4 ? "bg-[#92D16B]" : "bg-[#92D16B]"} w-2 h-2 rounded-[8px]`} />
                    <div className={` ${password.length < 7 ? "bg-[#D9D9D9]" : strength === 1 ? "bg-[#D9D9D9]" : strength === 2 ? "bg-[#EB0728]" : strength === 3 ? " bg-yellow-300" : strength >= 4 ? "bg-[#92D16B]" : "bg-[#92D16B]"} w-2 h-2 rounded-[8px]`} />
                    <div className={` ${password.length < 8 ? "bg-[#D9D9D9]" : strength === 3 ? " bg-yellow-300" : strength >= 4 ? "bg-[#92D16B]" : ""} w-2 h-2 rounded-[8px]`} />
                    <div className={` ${password.length >= 8 && strength >= 4 ? "bg-[#92D16B]" : "bg-[#D9D9D9]"} w-2 h-2 rounded-[8px]`} />
                    <div className={` ${password.length >= 8 && strength >= 5 ? "bg-[#92D16B]" : "bg-[#D9D9D9]"} w-2 h-2 rounded-[8px]`} />
                  </div>
                  <div onClick={togglePasswordVisibility} className='-ml-[42px] mt-[15px] cursor-pointer '>
                    {showPassword ? <img src={visibility_on} alt="" /> : <img src={visibility_off} alt="" />}
                  </div>
                </div>
                
              </div>
            </div>

            {/** Confirm Password */}
            <div className='  box-border m-0 flex-grow-0 max-w-full'>
              <div className=' box-border flex flex-wrap w-full'>
                <div className='w-full flex items-start'>
                  <div className=' w-full'>
                    <input value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required type={showConfirmPassword ? "text" : "password"} name="confirm password" id="confirm_password" data-cy="password" placeholder="Re-enter password" className={`${errorMessage === "Confirm Password" || errorMessage === "Passwords do not match" ? " border-[1px] border-[#EB0728]" : ""} pl-[20px] md:pl-[23px]  lg:pl-[29px]  m-0 placeholder:text-ravinput text-ravdeepblue text-base lg:text-[15px]  w-full font-medium bg-ravbg h-[45px] lg:h-[50px] rounded-[30px] pl-5 `} />
                    {errorMessage === "Confirm Password" || errorMessage === "Passwords do not match" ? <h1 className=' pl-5 w-full mt-[5px] text-red-600 text-[12px] text-left'>{errorMessage}</h1> : null}
                  </div>
                  <div onClick={toggleConfirmPasswordVisibility} className='-ml-[35px] mt-[15px] cursor-pointer '>
                    {showConfirmPassword ? <img src={visibility_on} alt="" /> : <img src={visibility_off} alt="" />}
                  </div>
                </div>
              </div>

            </div>

            {/**Button */}
            <button type="submit" className='mt-[12px] w-full h-[45px] lg:h-[50px] rounded-[80px] bg-ravblue flex items-center justify-center text-center font-bold text-sm text-white hover:opacity-70 transform transition-all ease-in-out duration-300'>Change password</button>
          </form>
          <button onClick={() => { setForgotPasswordSteps(-1); scrollToTop() }} type="button" className=' mt-[18px] sm:mt-[20px] font-bold text-xs sm:text-base text-ravinput'>BACK TO LOGIN</button>
        </div> : null}

      {forgotPasswordSteps === 3 ?
        <div className='  flex flex-col justify-center items-center text-center mt-[36px] sm:mt-[19px]'>
          <img src={successIcon} alt="successIcon" className=' w-[57.6px] h-[57.6px]' />
          <h1 className=' mt-[13.4px] sm:mt-[14.4px] font-black text-ml sm:text-[24px] leading-[32.4px] mg:text-xxl text-ravdeepblue '>Password Reset</h1>
          <div className='md:flex flex-wrap gap-1 lg:flex-col lg:gap-0'>
            <p className=' mt-[9px] md:mt-0 lg:mt-[8px] font-normal text-base text-ravash'>Your password has been successfully reset. </p>
            <p className='   font-normal text-base text-ravash leading-[21.6px]'> Click below to login</p>
          </div>
          <button onClick={() => setForgotPasswordSteps(-1)} className=' mt-[27px] w-full h-[45px] lg:h-[50px] rounded-[80px] bg-ravblue flex items-center justify-center text-center font-bold text-sm text-white  hover:opacity-70 transform transition-all ease-in-out duration-300'>Login</button>
        </div> : null
      }


      <div className='flex justify-center gap-[10px] sm:gap-[22px]'>
        {[0, 1, 2, 3].map((index) => (
          <div
            key={index}
            className={`h-[8px] w-[55px]  xl:w-[100px] 
                  rounded-[80px] ${progressBar === index ? 'bg-ravblue' : 'bg-ravbackground'}`}
          />
        ))}
      </div>
    </div>
  )
}

export default ForgotPassword
